// eslint-disable-next-line max-len
import { IGeneralPetCareItem, IGetGeneralPetCareResponse } from "../../services/Standard-of-care/standard-of-care.interface";
import { IPrescriptionResponse } from "../../services/prescription/prescription.interface";
import { actionTypes } from "./petCare.actions";

export interface IPetCareState {
  petCareData: IGetGeneralPetCareResponse | undefined;
  petCareUpdate: boolean;
  selectedPrescription: IPrescriptionResponse | null;
  selectedPet?: IGeneralPetCareItem;
}

const initialState: IPetCareState = {
  petCareData: undefined,
  petCareUpdate: false,
  selectedPrescription: null,
  selectedPet: undefined,
};

export const petCareReducer = (
  state: IPetCareState = initialState,
  action: { type: string, payload: any },
): IPetCareState => {
  switch (action.type) {
  case actionTypes.SET_PET_CARE_DATA:
    return {
      ...state,
      petCareData: action.payload,
    };
  case actionTypes.UPDATE_FULFILLED_MONTH_STATUS:
    if (state.petCareData) {
      const { petId, updatePetData } = action.payload;

      const updatedPets = state.petCareData.pets.map((pet) => {
        if (pet.id === petId) {
          return updatePetData;
        }

        return pet;
      });

      return {
        ...state,
        petCareData: { ...state.petCareData, pets: updatedPets },
        selectedPet: state.selectedPet?.id === petId ? updatePetData : state.selectedPet,
      };
    }

    return state;
  case actionTypes.SET_SELECTED_PRESCRIPTION:
    return {
      ...state,
      selectedPrescription: action.payload,
    };
  case actionTypes.SET_SELECTED_PET:
    return {
      ...state,
      selectedPet: action.payload,
    };

  default:
    return state;
  }
};
